<div class="container font-white bg-gray">
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <div class="fw-semibold fs-32">Create Event</div>
      <!-- <div class="fs-14 fw-normal mb-3">Fill up all your details and create a class.</div> -->
    </div>
    <!-- <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" class="cursor-pointer" ></div> -->
  </div>
</div>

<div class="container font-white d-flex bg-gray">
  <div class="flex-grow-1">
    <form>
      <!-- Error Messages -->
      @if(ErrorMsg.length > 0){
      <div AsteriskMessage [messageList]="ErrorMsg"></div>
      }
      <div>
        <div class="row g-3">
          <div class="col-md-4 col-12 mt-4">
            <label for="EventName" class="fs-14 fw-normal font-white">Event Name <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="eventData.EventName" maxlength="45" name="EventName" placeholder="Event Name" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="EventDescription" class="fs-14 fw-normal font-white">Event Description <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="eventData.EventDescription" maxlength="45" name="EventDescription" placeholder="Event Description" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="EventType" class="fs-14 fw-normal font-white">Event Type <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="eventData.EventType" maxlength="45" name="EventType" placeholder="Event Type" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="StartDate" class="fs-14 fw-normal font-white">Event Start Date <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" type="date" [(ngModel)]="eventData.StartDate" name="StartDate" placeholder="Event Start Date" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="EndDate" class="fs-14 fw-normal font-white">Event End Date <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" type="date" [(ngModel)]="eventData.EndDate" name="EndDate" placeholder="Event End Date" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="RegistrationLastDate" class="fs-14 fw-normal font-white">Registration Last Date<span class="text-danger">*</span></label>
            <input
              class="form-control bg-form-control border-0 font-white w-100"
              [(ngModel)]="eventData.RegistrationLastDate"
              type="date"
              name="RegistrationLastDate"
              placeholder="Registration Last Date" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="Venue" class="fs-14 fw-normal font-white">Venue <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="eventData.Venue" maxlength="45" name="Venue" placeholder="Venue" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="City" class="fs-14 fw-normal font-white">City <span class="text-danger">*</span></label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="eventData.City" maxlength="45" name="City" placeholder="City" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="MaxParticipants" class="fs-14 fw-normal font-white">Max Participants </label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="eventData.MaxParticipants" maxlength="45" name="MaxParticipants" placeholder="Max Participants" />
          </div>
          <div class="col-md-4 col-12 mt-4">
            <label for="RegistrationFee" class="fs-14 fw-normal font-white">Registration Fees </label>
            <input class="form-control bg-form-control border-0 font-white w-100" [(ngModel)]="eventData.RegistrationFee" maxlength="45" name="RegistrationFee" placeholder="Registration Fee" />
          </div>

          <div class="col-12 mt-2">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="IsActive" [(ngModel)]="eventData.IsActive" name="IsActive" />
              <label class="form-check-label font-white" for="IsActive">Is Active</label>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 d-flex gap-3 justify-content-end mb-4">
        <button type="submit" class="close-btn px-4 py-2" (click)="onClose()">Cancel</button>

        <button type="submit" class="add-btn px-4 py-2" (click)="onSubmit()">Submit</button>
      </div>
    </form>
  </div>
</div>
